import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import SmsCorner from '../icons/sms-bubble-corner.svg';
import styles from './styles.module.scss';
import { Card } from '../../../../infra/ui/card/card';
export var SmsContentBubble = function (_a) {
    var children = _a.children;
    return (_jsxs("div", { className: styles['sms-content-bubble-wrapper'], children: [_jsx(Card, { borderWidth: 1, radius: "m", padding: 4, className: styles['sms-content-bubble-card'], children: children }), _jsx(SmsCorner, { className: styles['corner-icon'] })] }));
};
